import { isMatching, P } from 'ts-pattern';
import {
  SETTLEMENT_PERIOD_TYPE,
  SETTLEMENT_PRODUCT_MANAGEMENT_TYPE,
  SETTLEMENT_SEARCH_PERIOD_TYPE,
} from '../constants';

export const isSettlementForm = isMatching({
  searchPeriodType: P.union(
    SETTLEMENT_SEARCH_PERIOD_TYPE.정산_기준일,
    SETTLEMENT_SEARCH_PERIOD_TYPE.정산_예정일,
    SETTLEMENT_SEARCH_PERIOD_TYPE.정산_완료일,
  ),
  searchPeriodStartDate: P.optional(P.string),
  searchPeriodEndDate: P.optional(P.string),
  periodType: P.union(SETTLEMENT_PERIOD_TYPE.전체, SETTLEMENT_PERIOD_TYPE.월간_정산, SETTLEMENT_PERIOD_TYPE.일간_정산),
  monthlyExecutionPeriod: P.optional(P.string),
  monthlyExecutionDay: P.optional(P.string),
  quickDate: P.optional(P.union('1' as const, '2' as const, '3' as const, 'ALL' as const, 'TODAY' as const)),
});

export const isSettlementByBrandForm = isMatching({
  searchType: P.union('ids' as const, 'names' as const),
  searchText: P.string,
  periodType: P.union(SETTLEMENT_PERIOD_TYPE.전체, SETTLEMENT_PERIOD_TYPE.월간_정산, SETTLEMENT_PERIOD_TYPE.일간_정산),
  productManagementTypes: P.optional(
    P.union(
      P.array(
        P.union(
          SETTLEMENT_PRODUCT_MANAGEMENT_TYPE.위탁생산,
          SETTLEMENT_PRODUCT_MANAGEMENT_TYPE.입고상품,
          SETTLEMENT_PRODUCT_MANAGEMENT_TYPE.입점상품,
        ),
      ),
      P.union(
        SETTLEMENT_PRODUCT_MANAGEMENT_TYPE.위탁생산,
        SETTLEMENT_PRODUCT_MANAGEMENT_TYPE.입고상품,
        SETTLEMENT_PRODUCT_MANAGEMENT_TYPE.입점상품,
      ),
    ),
  ),
});
